import { observable } from 'mobx';
import moment from 'moment';

import { getVisibleRows, stopsToGroupRows, stopsToRows } from '../util/stops';

import commonStore from './commonStore';

const componentsByLabel = {
  Pysäkkijuliste: 'StopPoster',
  Aikataulu: 'Timetable',
};

const stopPosterPrintSizes = {
  Auto: 'Auto',
  A0: 'A0',
  A3: 'A3',
  A4: 'A4',
  Vilkku: 'CUSTOM',
};

const rowTypesByLabel = {
  Pysäkit: 'stop',
  // Ajolistat: 'group',
  Linjat: 'route',
};

const store = observable({
  componentsByLabel,
  stopPosterPrintSizes,
  rowTypesByLabel,
  component: 'StopPoster',
  rowType: 'stop',
  date: new Date(),
  dateBegin: null,
  dateEnd: null,
  isSummerTimetable: false,
  buildId: null,
  stopPosterPrintSize: stopPosterPrintSizes.Auto,
  hasTwoFrames: false,
  timetableAsA4Format: true,
  timetableAsGreyscale: false,
  checkedRows: [],
  get rows() {
    let rows = [];

    if (store.rowType === 'stop') {
      rows = stopsToRows(commonStore.stops);
    } else {
      rows = stopsToGroupRows(commonStore.stops, store.rowType);
    }

    return getVisibleRows(rows, commonStore.stopFilter);
  },
});

store.setComponent = value => {
  store.component = value;
};

store.setStopPosterPrintSize = value => {
  store.stopPosterPrintSize = value;
};

store.setHasTwoFrames = value => {
  store.hasTwoFrames = value;
};

store.setTimetableA4Format = value => {
  store.timetableAsA4Format = value;
};

store.setTimetableGreyscale = value => {
  store.timetableAsGreyscale = value;
};

store.setRowType = value => {
  store.rowType = value;
};

store.setDate = value => {
  store.date = value;
};

store.setDateBegin = value => {
  store.dateBegin = value;
};

store.setDateEnd = value => {
  store.dateEnd = value;
};

store.setIsSummerTimetable = value => {
  store.isSummerTimetable = !!value;
};

store.setChecked = (rows = [], isChecked) => {
  const rowIds = rows.map(row => row.rowId);

  if (isChecked) {
    store.checkedRows = [...store.checkedRows.slice(), ...rowIds];
  } else {
    store.checkedRows = store.checkedRows.filter(rowId => !rowIds.includes(rowId));
  }
};

store.resetChecked = () => {
  store.checkedRows = [];
};

store.setBuildId = id => {
  store.buildId = id;
};

store.generate = () => {
  const format = date => moment(date).format('YYYY-MM-DD');
  const props = store.rows
    .filter(({ rowId }) => store.checkedRows.includes(rowId))
    .reduce(
      (prev, { stops, printOrder, posterCount, printSize }) => [
        ...prev,
        ...stops.map(
          ({
            stopId,
            printOrder: stopPrintOrder,
            posterCount: stopPosterCount,
            printSize: stopPrintSize,
          }) => ({
            stopId,
            printOrder: stopPrintOrder || printOrder,
            posterCount: stopPosterCount || posterCount,
            printSize: stopPrintSize || printSize,
          }),
        ),
      ],
      [],
    )
    .map(stop => ({
      stopId: stop.stopId,
      printOrder: stop.printOrder ? stop.printOrder : 1,
      date: format(store.date),
      isSummerTimetable: store.isSummerTimetable,
      dateBegin: store.dateBegin ? format(store.dateBegin) : null,
      dateEnd: store.dateEnd ? format(store.dateEnd) : null,
      stopPosterPrintSize:
        store.stopPosterPrintSize === stopPosterPrintSizes.Auto
          ? stop.printSize === 'vilkku'
            ? stopPosterPrintSizes.Vilkku
            : stop.printSize
          : store.stopPosterPrintSize,
      hasTwoFrames:
        store.stopPosterPrintSize === stopPosterPrintSizes.Auto
          ? stop.posterCount > 1
          : store.hasTwoFrames &&
            (store.stopPosterPrintSize === stopPosterPrintSizes.A3 ||
              store.stopPosterPrintSize === stopPosterPrintSizes.A4),
      printTimetablesAsA4:
        store.timetableAsA4Format && store.component === componentsByLabel.Aikataulu,
      printTimetablesAsGreyscale:
        store.timetableAsGreyscale && store.component === componentsByLabel.Aikataulu,
    }));

  store.resetChecked();
  commonStore.addPosters(store.buildId, store.component, props);
};

export default store;



// WEBPACK FOOTER //
// ./src/stores/generatorStore.js